export default "__VITE_ASSET__BKtcLhyR__"